import { VernostServiceService } from "./vernost-service.service";
import { Injectable } from "@angular/core";
// module.exports = class Log_service {

// };
@Injectable()
export class Loggerservice {
  constructor(private vernostService: VernostServiceService) { }
  //for Fare product
  create_log(message, error_type) {    
  }

  create_log_masters(message, error_type) {
  }

  create_log_RPM(message, error_type) {
  }
}
